import { closeIcon } from '@/shared/ui/assets';
import { StudyInfoDrawer } from '@/entities/study';
import {
  NoDataComponent,
  SkeletonGradientBackground,
  TableComponent,
  CustomButton,
} from '@/shared/ui/components';

import { isFacilitySubscribeProtectPlus, facilitySelection } from '@/entities/facility';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import { t } from 'ttag';
import { useDevicesTable } from './useDevicesTable';
import type { DevicesTableProps } from './devicesTable.types';
import './devicesTable.scss';

const EMPTY_ARRAY: any[] = [];

const DevicesTable = ({
  isActive,
  type,
  eventsNoti = EMPTY_ARRAY,
  toggleDisplayDrawer,
  searchGoto,
  selectedFacility,
  searchByValue,
  searchValue,
  supportFacilities,
  model,
  selectGoto,
  isUnused,
  isTicketCountVisible = false,
}: DevicesTableProps) => {
  const {
    state,
    isMaintenanceSubtab,
    checkedDeviceIds,
    rowSelection,
    filterObject,
    closeDrawer,
    onClickRemoveAllSelectedDevices,
    handleClickInitiateProtectPlus,
    generateColumns,
    handleTableChange,
  } = useDevicesTable({
    isActive,
    type,
    eventsNoti,
    toggleDisplayDrawer,
    searchGoto,
    selectedFacility,
    searchByValue,
    searchValue,
    supportFacilities,
    model,
    selectGoto,
    isUnused,
  });

  return (
    (isActive || state.isLoadedData) && (
      <>
        <StudyInfoDrawer
          visible={state.isDrawerStudyInfo}
          fetchStudyId={state.fetchStudyId}
          handleClickCloseButton={() => {
            closeDrawer();
          }}
        />

        <div className="devices-table-container" id="devices-table-container">
          {isMaintenanceSubtab &&
            (checkedDeviceIds?.length > 0 && state.devices.length > 0 ? (
              <div className="selected-maintenance-device">
                <CustomButton
                  id="remove-all-selected-devices-btn"
                  style="neutral"
                  type="tertiary"
                  size="small"
                  className="remove-all-selected-devices-btn"
                  icon={<ReactSVG src={closeIcon} />}
                  onClick={onClickRemoveAllSelectedDevices}
                  ariaLabel={t`Clear selection`}
                />
                <div className="selected-devices">
                  <span className="devices-number">{checkedDeviceIds.length}</span>
                  {checkedDeviceIds.length > 1 ? ' devices selected' : ' device selected'}
                </div>
                <CustomButton
                  id="initiate-protect-plus-btn"
                  className="initiate-protect-plus-btn"
                  onClick={() => {
                    handleClickInitiateProtectPlus();
                  }}
                  type="tertiary"
                  size="small"
                >
                  {isFacilitySubscribeProtectPlus(state.firstCheckedDeviceFacility?.programs)
                    ? t`Initiate Protect+ program`
                    : t`Initiate RMA request`}
                </CustomButton>
              </div>
            ) : (
              <div className="selected-maintenance-device-empty" />
            ))}

          <div
            className={classNames(
              'custom-body',
              !state.isLoadedData &&
                (facilitySelection.userSupportFacilities()?.length > 0 ||
                  (supportFacilities?.length ?? 0) > 0)
                ? 'relative'
                : '',
            )}
          >
            <SkeletonGradientBackground isShow={!state.isLoadedData} />

            {(state.devices.length || (!state.devices.length && !state.isLoadedData)) &&
            (facilitySelection.userSupportFacilities()?.length > 0 ||
              (supportFacilities?.length ?? 0) > 0) ? (
              <TableComponent
                className="devices-table"
                columns={generateColumns()}
                data={state.devices}
                isLoading={!state.isLoadedData}
                pageSize={state.sizePerPage}
                currentPage={state.devicesPage}
                handleTableChange={handleTableChange}
                isEndOfData={state.isEndOfData}
                rowSelection={rowSelection}
                rowKey="deviceId"
                scrollX={1335}
                ticketCount={isTicketCountVisible ? state.deviceTicketCount : 0}
              />
            ) : (
              <div className="no-data-wrapper">
                <div className="no-data">
                  <NoDataComponent
                    isSearching={
                      !!filterObject.current.deviceId || !!filterObject.current.fwVersion
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    )
  );
};

export default DevicesTable;
